var _circle, _circle2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBatteryBackwheels1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 507,
    height: 105,
    viewBox: "0 0 507 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 454.469,
    cy: 52.3639,
    r: 45.7354,
    fill: "#9AFF6B",
    stroke: "black",
    strokeWidth: 12.1961
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 443.01,
    cy: 52.3639,
    r: 45.7354,
    fill: "black",
    stroke: "#9AFF6B",
    strokeWidth: 12.1961
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.2018,
    cy: 52.3639,
    r: 45.7354,
    fill: "#9AFF6B",
    stroke: "black",
    strokeWidth: 12.1961
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.7408,
    cy: 52.3639,
    r: 45.7354,
    fill: "black",
    stroke: "#9AFF6B",
    strokeWidth: 12.1961
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryBackwheels1);
export default __webpack_public_path__ + "static/media/battery-backwheels1.8a913adeee29e01b7eee8daa242828d2.svg";
export { ForwardRef as ReactComponent };